import { render, staticRenderFns } from "./TermView.vue?vue&type=template&id=75f82dc3&scoped=true"
import script from "./TermView.vue?vue&type=script&lang=js"
export * from "./TermView.vue?vue&type=script&lang=js"
import style0 from "./TermView.vue?vue&type=style&index=0&id=75f82dc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f82dc3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer})
